"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RecordNotFoundError", {
    enumerable: true,
    get: function() {
        return RecordNotFoundError;
    }
});
const _errorwithcause = require("./error-with-cause");
let RecordNotFoundError = class RecordNotFoundError extends _errorwithcause.ErrorWithCause {
    constructor(...args){
        super(...args);
        this.name = 'RecordNotFoundError';
    }
};

//# sourceMappingURL=record-not-found.error.js.map